import { render, staticRenderFns } from "./ChartsComponent.vue?vue&type=template&id=06f56dd5&scoped=true"
import script from "./ChartsComponent.vue?vue&type=script&lang=js"
export * from "./ChartsComponent.vue?vue&type=script&lang=js"
import style0 from "./ChartsComponent.vue?vue&type=style&index=0&id=06f56dd5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f56dd5",
  null
  
)

export default component.exports